import styled from 'styled-components';
import LeftArrowIcon from '../../assets/images/arrow.svg';

const ArrowIcon = styled.span`
  background: url(\"${LeftArrowIcon}\") no-repeat left center;
  background-size: 17px 17px;
  display: block;
  position: relative;
  width: 20px;
`;

export default ArrowIcon;
